// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3s-1";
export var rateTableServiceLevelDropdown = "_3s-3";
export var rateTableTypeDropdown = "_3s-0";
export var rateTableValueModeDropdown = "_3s-2";